import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperIsPhoneCss = "w11s8mx4";
const wrapperCss = "w13g5j0o";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const inviteeListItemCss = "i1u2gvqd";
const InviteeListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(inviteeListItemCss, props.className)} />;
});
const inviteeDetailsCss = "i1sl1jfu";
const InviteeDetails = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inviteeDetailsCss, props.className)} />;
});
const inviteeSectionCss = "i13lpg6f";
const InviteeSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inviteeSectionCss, props.className)} />;
});
const nameCss = "n1j860us";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const emailCss = "eeqi1bo";
const Email = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailCss, props.className)} />;
});
const Invitee = ({
  name,
  email,
  hideRemove,
  onClickRemove
}) => <InviteeListItem data-testid="invitee_info">
    <InviteeSection>
      <FullStoryExclude>
        <Avatar letter={name.charAt(0)} size="small" aria-hidden tabIndex={-1} />
      </FullStoryExclude>
      <InviteeDetails>
        <Name><FullStoryMask>{name}</FullStoryMask></Name>
        <Email><FullStoryMask>{email}</FullStoryMask></Email>
      </InviteeDetails>
    </InviteeSection>
    {!hideRemove && <IconButton size="small" title={I18n.t('action.remove')} onClick={onClickRemove}>
        <CloseMiniIcon />
      </IconButton>}
  </InviteeListItem>;
export const InviteesList = ({
  invitees,
  additionalInvitees,
  onClickRemove
}) => {
  if (!invitees.length) return null;
  const disableRemoveButton = invitees.length < 2;
  const allInvitees = [...invitees, ...additionalInvitees];
  const sortedInvitees = allInvitees.sort((inviteeA, inviteeB) => inviteeA.fullName.localeCompare(inviteeB.fullName));
  return <Wrapper>
      {sortedInvitees.map(invitee => {
      const {
        fullName,
        email,
        id
      } = invitee;
      return <Invitee key={id || email} id={id || email} name={fullName} email={email} hideRemove={disableRemoveButton && invitee.id} onClickRemove={() => onClickRemove(invitee)} />;
    })}
    </Wrapper>;
};

require("./invitees_list.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitees_list.js");